import './map.css'

const Map = () => {
  return (
    <iframe title='google-map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d610.2217262183707!2d21.081888330384224!3d52.28175515425472!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471ece8839e7eae1%3A0x63e1bd108c055360!2sDiamentowa%2016A%2C%2003-682%20Warszawa%2C%20Polska!5e0!3m2!1spl!2sno!4v1692532425600!5m2!1spl!2sno" className='map' allowFullScreen="yes" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
  )
}

export default Map